import cover from "../../../../assets/Users/cover.png";
import { CommonImages } from "../../../../reusableUI/images";
import { useState, Fragment } from "react";
import { updatePassword } from "../../../../Service/RM";
import secureLocalStorage from "react-secure-storage";
import Loader from "../../../../reusableUI/loader";
import { showToast } from "../../../../reusableUI/toaster";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";

const Account = () => {
  const [showModal, setShowModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [casedata, setCase] = useState([]);
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const email = secureLocalStorage.getItem("email");
  // console.log(email);
  const validatePasswords = () => {
    const newErrors = {};

    if (!passwordData.currentPassword) {
      newErrors.currentPassword = "Current password is required";
    }

    if (!passwordData.newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (passwordData.newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters long";
    }

    if (!passwordData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (passwordData.newPassword !== passwordData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdatePassword = async () => {
    const confirmUpdate = window.confirm(
      "Are you sure you want to update your password?"
    );
    if (!confirmUpdate) {
      return;
    }
    if (validatePasswords()) {
      const data = {
        email: email,
        password: passwordData.newPassword,
        existingPassword: passwordData.currentPassword,
      };
      console.log("Password update payload:", data);
      setLoading(true);
      try {
        const req = await updatePassword(data);
        console.log(req);
        if (req.error === false) {
          console.log("Password updated:", req.data);
          setShowModal(false);
          setPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          showToast("Password Updated Successfully.", "Success");
        } else {
          console.log("Update failed:", req.data);
          showToast(req.message, "Error");
        }
      } catch (err) {
        console.error("Error while updating password:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  const role = secureLocalStorage.getItem("role");
  console.log(role);
  return (
    <div>
      {loading ? (
        <div className="">
          <Loader loading={loading} />
        </div>
      ) : (
        <Fragment>
          <div className="bg-white px-6 py-3 shadow-sm">
            <h1 className="text-xl font-bold text-gray-800">User Account</h1>
          </div>
          <div className="bg-[#F3F6F5]">
            <div className="w-[98%] bg-white rounded-2xl overflow-hidden h-[85vh] shadow-lg mt-2 m-2">
              <div
                className="relative text-center w-full bg-cover bg-no-repeat"
                style={{ backgroundImage: `url(${cover})`, height: 120 }}
              >
                <img
                  src={CommonImages.CommonDp}
                  alt="Profile"
                  className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 h-20 w-20 rounded-full border-4 border-white"
                />
              </div>
              <div className="mt-10 text-center">
                <h4 className="mt-1 text-lg font-semibold">Edit</h4>
              </div>
              <div className="mt-4 mb-12 flex flex-col justify-around mx-10">
                <div className="flex flex-row justify-between items-center w-full mb-4">
                  <div className="p-5">
                    <h2 className="text-lg font-semibold mb-2">Name</h2>
                    <p className="mt-1 mb-2 text-[16px]">
                      {" "}
                      {role === "super user"
                        ? "Admin"
                        : role === "support"
                          ? "User Support"
                          : "Relationship Manager"}
                    </p>
                    <button className="text-blue-600 hover:underline text-[16px]">
                      Change Name
                    </button>
                  </div>
                  {/* <div className="p-5">
                <h2 className="text-lg font-semibold mb-2">Mail ID</h2>
                <p className="mt-1 mb-2 text-[16px] ">
                  {role === "super user"
                    ? "admin@ceviliyar.com"
                    : role === "support"
                    ? "support@ceviliyar.com"
                    : "rm@ceviliyar.com"}
                </p>
                <button className="text-blue-600 hover:underline text-[16px]">
                  Change Mail ID
                </button>
              </div> */}
                </div>
                <div className="flex flex-row justify-between items-center w-full">
                  <div className="p-5">
                    <h2 className="text-lg font-semibold mb-2">Password</h2>
                    <p className="mt-1 mb-2 text-[16px]">********</p>
                    <button
                      onClick={() => setShowModal(true)}
                      className="text-blue-600 hover:underline text-[16px]"
                    >
                      Change Password
                    </button>
                  </div>
                  {/* <div className="p-5 mr-[60px]">
                <h2 className="text-lg font-semibold mb-2">Account</h2>
                <button className="text-blue-600 hover:underline text-[16px] mb-2">
                  Add Account
                </button>
                <button className="text-[#AE2727] hover:underline">
                  Logout
                </button>
              </div> */}
                </div>
              </div>
            </div>
          </div>

          {showModal ? (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="bg-white p-8 rounded-sm w-96">
                <h2 className="text-[18px] font-semibold mb-6">
                  Update Password
                </h2>

                <div className="space-y-4">
                  {/* Current Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Current Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPasswords.current ? "text" : "password"}
                        value={passwordData.currentPassword}
                        onChange={(e) =>
                          setPasswordData({
                            ...passwordData,
                            currentPassword: e.target.value,
                          })
                        }
                        className="w-full px-3 py-1.5 text-[12px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter current password"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPasswords((prev) => ({
                            ...prev,
                            current: !prev.current,
                          }))
                        }
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      >
                        {showPasswords.current ? (
                          <IoEyeOffOutline />
                        ) : (
                          <FaRegEye />
                        )}
                      </button>
                    </div>
                    {errors.currentPassword && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.currentPassword}
                      </p>
                    )}
                  </div>

                  {/* New Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      New Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPasswords.new ? "text" : "password"}
                        value={passwordData.newPassword}
                        onChange={(e) =>
                          setPasswordData({
                            ...passwordData,
                            newPassword: e.target.value,
                          })
                        }
                        className="w-full px-3 py-1.5 text-[12px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter new password"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPasswords((prev) => ({
                            ...prev,
                            new: !prev.new,
                          }))
                        }
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      >
                        {showPasswords.new ? <IoEyeOffOutline /> : <FaRegEye />}
                      </button>
                    </div>
                    {errors.newPassword && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.newPassword}
                      </p>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Confirm Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPasswords.confirm ? "text" : "password"}
                        value={passwordData.confirmPassword}
                        onChange={(e) =>
                          setPasswordData({
                            ...passwordData,
                            confirmPassword: e.target.value,
                          })
                        }
                        className="w-full px-3 py-1.5 text-[12px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Confirm new password"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPasswords((prev) => ({
                            ...prev,
                            confirm: !prev.confirm,
                          }))
                        }
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      >
                        {showPasswords.confirm ? (
                          <IoEyeOffOutline />
                        ) : (
                          <FaRegEye />
                        )}
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.confirmPassword}
                      </p>
                    )}
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-end gap-4 mt-6">
                    <button
                      onClick={() => {
                        setShowModal(false);
                        setPasswordData({
                          currentPassword: "",
                          newPassword: "",
                          confirmPassword: "",
                        });
                        setErrors({});
                      }}
                      className="px-4 py-2 text-gray-600 text-[13px] hover:bg-gray-100 rounded-md"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleUpdatePassword}
                      className="px-3 py-1 bg-custom-gradient text-[13px] text-white rounded-md hover:bg-blue-700"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
        </Fragment>
      )}
    </div>
  );
};

export default Account;
